// extracted by mini-css-extract-plugin
export var heroImage = "_ca-1";
export var modal = "_ca-0";